import React from 'react';
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import LoginScreen from './Screens/LoginScreen';
import { Bounce, ToastContainer } from 'react-toastify';
import HomeScreen from './Screens/HomeScreen';
import { PrimeReactProvider } from "primereact/api";
import "primereact/resources/primereact.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primeicons/primeicons.css";
import { Provider } from 'react-redux';
import store from './store/store';
import Auth from './components/Auth';

const App = () => {
  const router = createBrowserRouter([
    {
      path: "/",
      element: <LoginScreen />
    },
    {
      path: "/home",
      element: <Auth>
        <HomeScreen />
        </Auth>
    },
  ])
  return (
    <>
      <ToastContainer
        // position="bottom-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
        transition={Bounce}
      />
      <Provider store={store}>

        <PrimeReactProvider>
          <RouterProvider router={router} />
        </PrimeReactProvider>
      </Provider>
    </>

  )
}

export default App;